import { startRegistration } from '@simplewebauthn/browser';
import { useState } from 'react';
import {
    PublicKeyCredentialTypeDtoEnum,
    useInvalidateRepositoryQuery,
    useRepositoryMutation,
    useRepositoryQuery,
} from '@mews-commander/data-access';
import { captureWithSentry, LocalizedText, showErrorAlert, showSuccessAlert } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { SentryTeams } from '@mews/enums';

export const usePasskeyAdd = (onSuccess?: () => void) => {
    const invalidateQuery = useInvalidateRepositoryQuery();
    const [isPending, setIsPending] = useState(false);

    const { refetch: refetchOptions } = useRepositoryQuery('users', 'getCredentialOptions', {}, { enabled: false });
    const { mutateAsync: registerCredentials } = useRepositoryMutation('users', 'registerCredentials');

    const getVerificationResponse = async () => {
        const { data: authOptions } = await refetchOptions();

        if (!authOptions) {
            return;
        }

        const tryPasskeyRegistration = captureWithSentry({
            fn: async () =>
                await startRegistration({
                    // @ts-expect-error incorrect type in API TODO DX-5802
                    optionsJSON: authOptions,
                }),
            onError: () => {
                showErrorAlert({
                    title: <LocalizedText textKey={TextKey.SettingsSecurityPasskeysAddErrorTitle} />,
                    description: <LocalizedText textKey={TextKey.SettingsSecurityPasskeysAddErrorDescription} />,
                });
            },
            team: SentryTeams.Users,
        });

        const registrationResponse = await tryPasskeyRegistration();

        if (!registrationResponse) {
            return;
        }

        return registerCredentials({
            // @ts-expect-error incorrect type in API TODO DX-5802
            attestationResponse: {
                ...registrationResponse,
                type: PublicKeyCredentialTypeDtoEnum.PublicKey,
            },
        });
    };

    const handlePasskeyAdd = async () => {
        setIsPending(true);

        try {
            const verificationResponse = await getVerificationResponse();

            if (verificationResponse) {
                void invalidateQuery('users', 'getRegisteredCredentials');
                showSuccessAlert({
                    title: <LocalizedText textKey={TextKey.SettingsSecurityPasskeysAddSuccessTitle} />,
                    description: <LocalizedText textKey={TextKey.SettingsSecurityPasskeysAddSuccessDescription} />,
                });
                onSuccess?.();
            }
            // eslint-disable-next-line @mews/no-empty-catch
        } catch (error) {
            // handled elsewhere
        }

        setIsPending(false);
    };

    return {
        handlePasskeyAdd,
        isPending,
    };
};
